var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoImageBackActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44601 0.877052C6.10742 0.369157 5.4212 0.231913 4.9133 0.57051L0.492286 3.51785C-0.0156097 3.85645 -0.152853 4.54267 0.185744 5.05056L3.13309 9.47158C3.47169 9.97948 4.1579 10.1167 4.6658 9.77812C5.17369 9.43953 5.31094 8.75331 4.97234 8.24541L3.26544 5.68506C5.26227 5.95156 7.1293 6.58883 8.59748 7.56762C10.5533 8.87146 11.7895 10.7609 11.7895 13.2795C11.7895 13.8899 12.2843 14.3848 12.8947 14.3848C13.5052 14.3848 14 13.8899 14 13.2795C14 9.90343 12.2889 7.37186 9.82365 5.72836C8.23485 4.66916 6.3295 3.97138 4.33197 3.61477L6.13947 2.40976C6.64737 2.07117 6.78461 1.38495 6.44601 0.877052Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImageBackActive);
export default __webpack_public_path__ + "static/media/ico_image_back_active.b5226e53a871c97622246e71ed95beed.svg";
export { ForwardRef as ReactComponent };